
(function () {
  const cards = document.querySelectorAll('product-card');
  const totalProducts = cards.length;

  let observedCount = 0;
  let batch = [];
  let batchIndex = 0;

  function buildItem(el) {
     console.log(el);
    // console.log(productInfo);
    let productInfo = JSON.parse(el.dataset.productInfo);
   
    return productInfo;
  }

  function fireEvent() {
    if (!batch.length) return;

    let itemListName = location.pathname.split('/collections/')[1]?.split('/')[0] || 'collection page';

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'ctu_view_item_list',
      event_action: 'product impression',
      event_type: 'productListEvent',
      ecommerce: {
        item_list_name: itemListName,
        currency: 'USD',
        items: batch
      }
    });

    batch = []; // reset after firing
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;

      if (el.dataset.tracked) return;

      el.dataset.tracked = '1';
      observer.unobserve(el);

      observedCount++;
      batch.push(buildItem(el));

      // Fire full batch
      if (batch.length === 4) {
        fireEvent();
      }

      
      if (observedCount === totalProducts) {
        fireEvent();
      }
    });
  }, { threshold: 0.6 });

  cards.forEach(el => observer.observe(el));
})();


/* ------------------------------------------------------------------
 * Cart GTM events:
 *   ctu_add_to_cart, ctu_increase_quantity,
 *   ctu_decrease_quantity, ctu_remove_from_cart
 *
 * Hooks into existing theme DOM events (no extra API calls needed):
 *   cart:item-add            → product-form.js  (carries added line item)
 *   cart:item-quantity-update → scripts.js       (carries full cart state)
 *   cart:item-remove          → scripts.js       (carries full cart state)
 *
 * Network budget: ONE /cart.js fetch on page load to seed the snapshot.
 * All subsequent snapshots come from event payloads (zero extra fetches).
 * ------------------------------------------------------------------ */
(function () {
  var getUserId = function () { return (window.__st && window.__st.cid) || ''; };
  var getCurrency = function () {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  };

  var prevCart = null;          // { items: [ … ] }

  var lower = function (v) { return typeof v === 'string' ? v.toLowerCase() : v; };
  var toMoney = function (cents) { return typeof cents === 'number' ? +(cents / 100).toFixed(2) : 0; };

  function buildGTMItem(line, overrideQty) {
    if (!line) return null;
    var originalPrice = typeof line.original_price === 'number' ? line.original_price : line.price;
    var finalPrice    = typeof line.final_price    === 'number' ? line.final_price    : line.price;
    var url = line.url
      ? (line.url.indexOf('http') === 0 ? line.url : window.location.origin + line.url)
      : '';

    return {
      item_id:             line.product_id   || null,
      item_sku:            line.sku           || null,
      item_name:           lower(line.product_title || line.title || ''),
      item_brand:          lower(line.vendor        || ''),
      item_category:       lower(line.product_type  || ''),
      list_position:       null,
      price:               toMoney(finalPrice),
      unit_sales_price:    toMoney(originalPrice),
      quantity:            typeof overrideQty === 'number' ? overrideQty : line.quantity,
      item_variant:        line.variant_id || line.id || null,
      item_type:           lower(line.variant_title  || ''),
      item_product_url:    url,
      is_grouped:          !!(window.__gtmGroupedProducts && window.__gtmGroupedProducts[line.product_id]),
      in_stock:            true,
      item_level_discount: 0
    };
  }

  function pushEvent(name, action, type, item) {
    if (!item) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:        name,
      event_action: action,
      event_detail: item.item_name || null,
      event_type:   type,
      user_id:      getUserId(),
      ecommerce: {
        currency: getCurrency(),
        value:    +(((item.price || 0) * (item.quantity || 1)).toFixed(2)),
        items:    [item]
      }
    });
  }

  /* ---- helpers to keep prevCart in sync without fetching ---- */

  /** After add-to-cart, splice the added line item into prevCart in-memory. */
  function patchPrevCartAfterAdd(addedLine) {
    if (!prevCart || !addedLine || !addedLine.key) return;
    var idx = -1;
    for (var i = 0; i < prevCart.items.length; i++) {
      if (prevCart.items[i].key === addedLine.key) { idx = i; break; }
    }
    if (idx >= 0) {
      prevCart.items[idx] = addedLine;          // existing line – qty was merged by Shopify
    } else {
      prevCart.items.push(addedLine);           // brand-new line
    }
  }

  /* ---- 1. ADD TO CART ---- */
  document.addEventListener('cart:item-add', function (event) {
    try {
      var raw   = (event.detail && event.detail.items) || [];
      var lines = [];
      raw.forEach(function (entry) {
        if (!entry) return;
        if (Array.isArray(entry))              lines.push.apply(lines, entry);
        else if (Array.isArray(entry.items))   lines.push.apply(lines, entry.items);
        else                                   lines.push(entry);
      });
      lines.forEach(function (line) {
        pushEvent('ctu_add_to_cart', 'add to cart', 'addEvent', buildGTMItem(line));
        patchPrevCartAfterAdd(line);
      });
    } catch (err) {
      console.warn('GTM add_to_cart error', err);
    }
  });

  /* ---- 2. INCREASE / DECREASE QUANTITY ---- */
  function processQuantityChange(newCart, previousCart) {

  if (previousCart) {
    prevCart = previousCart;
  }

  try {
    if (!newCart || !prevCart) return;

    var prevByKey = {};
    prevCart.items.forEach(function (it) {
      prevByKey[it.key] = it;
    });

    newCart.items.forEach(function (line) {

      var before = prevByKey[line.key];
      if (!before) return;

      var diff = line.quantity - before.quantity;
      if (diff === 0) return;

      var item = buildGTMItem(line, Math.abs(diff));

      if (diff > 0) {
        pushEvent('ctu_increase_quantity', 'increase quantity', 'cartEvent', item);
      } else {
        pushEvent('ctu_decrease_quantity', 'decrease quantity', 'cartEvent', item);
      }

    });

  } catch (err) {
    console.warn('GTM quantity-change error', err);
  } 
  // finally {
  //   if (newCart) {
  //     prevCart = newCart;
  //   }
  // }
}

function processRemove(newCart, previousCart) {

  try {

    if (!newCart || !previousCart) return;

    var newKeys = {};

    newCart.items.forEach(function (it) {
      newKeys[it.key] = true;
    });

    previousCart.items.forEach(function (line) {

      if (!newKeys[line.key]) {

        pushEvent(
          'ctu_remove_from_cart',
          'remove from cart',
          'removeEvent',
          buildGTMItem(line)
        );

      }

    });

  } catch (err) {
    console.warn('GTM remove_from_cart error', err);
  }

}

document.addEventListener('cart:item-quantity-update', function (event) {
   // console.log('quantity update fired');

  // processQuantityChange(
  //   event.detail && event.detail.cart,
  //   event.detail && event.detail.previousCart
  // );

   var newCart = event.detail && event.detail.cart;
    var previousCart = event.detail && event.detail.previousCart;

    processQuantityChange(newCart, previousCart);

    if (newCart) {
        prevCart = newCart;
        window.prevCart = newCart;
    }

});
(function () {

  const originalFetch = window.fetch;

  window.fetch = async function () {

    const response = await originalFetch.apply(this, arguments);

    let url = arguments[0];

    if (typeof url !== 'string') {
        url = url.url || '';
    }

    // <-- Add it HERE
    console.log("Fetch URL:", url);

    if (
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add')
    ) {

      setTimeout(async function () {

        try {

          const r = await originalFetch('/cart.js', {
            credentials: 'same-origin'
          });

          // const newCart = await r.json();

          // processQuantityChange(newCart, prevCart);

          const newCart = await r.json();

          var oldCart = prevCart;

          processQuantityChange(newCart, oldCart);
          processRemove(newCart, oldCart);

          prevCart = newCart;
          window.prevCart = newCart;

        } catch (e) {
          console.error(e);
        }

      }, 300);

    }

    return response;

  };

})();


(function () {

    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
        this._url = url;
        return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {

        this.addEventListener('load', async function () {

            if (
                this._url &&
                (
                    this._url.includes('/cart/change') ||
                    this._url.includes('/cart/update')
                )
            ) {

                try {

                    const r = await fetch('/cart.js', {
                        credentials: 'same-origin'
                    });

                    const newCart = await r.json();

                    var oldCart = prevCart;

                    processQuantityChange(newCart, oldCart);
                    processRemove(newCart, oldCart);

                    prevCart = newCart;
                    window.prevCart = newCart;

                } catch (e) {
                    console.error(e);
                }

            }

        });

        return send.apply(this, arguments);
    };

})();

document.addEventListener('cart:item-remove', function (event) {

  var newCart = event.detail && event.detail.cart;
  var previousCart = event.detail && event.detail.previousCart;

  processRemove(newCart, previousCart);

  if (newCart) {
    prevCart = newCart;
    window.prevCart = newCart;
  }

});


  document.addEventListener('rebuy:cart.change', function (event) {
    console.log('Rebuy Cart Changed');
    console.log(event.detail);
});

  /* ---- Seed prevCart once on page load (single /cart.js fetch) ---- */
  function seedCart() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) prevCart = cart;  window.prevCart = cart; })
      .catch(function () {});      // non-critical – first diff will simply be skipped
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seedCart);
  } else {
    seedCart();
  }
})();


/* ------------------------------------------------------------------
 * 4. PERCENTAGE SCROLLED
 *    Fires ctu_percentage_scrolled at 25%, 50%, 75% and 90% thresholds.
 *    Each threshold fires only once per page load.
 * ------------------------------------------------------------------ */
(function () {
  var thresholds = [25, 50, 75, 90];
  var fired = {};

  function getScrollPercent() {
    var docHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight
    );
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (docHeight <= viewportHeight) return 100;
    return Math.round((scrollTop / (docHeight - viewportHeight)) * 100);
  }

  function onScroll() {
    var pct = getScrollPercent();
    for (var i = 0; i < thresholds.length; i++) {
      var t = thresholds[i];
      if (pct >= t && !fired[t]) {
        fired[t] = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event:            'ctu_percentage_scrolled',
          event_action:     'scroll',
          event_detail:     t + '%',
          event_type:       'scrollEvent',
          scroll_threshold: t,
          page_location:    window.location.href
        });
      }
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
    }
  }, { passive: true });
})();


// /* ------------------------------------------------------------------
//  * 5. VIDEO PLAY / PROGRESS / COMPLETE  (YouTube iframe via postMessage)
//  *    Works with the theme's <deferred-media> component that lazy-loads
//  *    YouTube iframes with ?enablejsapi=1.
//  *    Fires:
//  *      ctu_video_play       — once when video starts
//  *      ctu_video_progress   — at 25%, 50%, 75% of duration (each once)
//  *      ctu_video_complete   — once when video ends
//  *    No additional YouTube API script is injected — we use the
//  *    lightweight postMessage / onStateChange + infoDelivery listener.
//  * ------------------------------------------------------------------ */
// (function () {
//   var tracked = {};   // keyed by iframe src to prevent duplicates

//   function getVideoTitle(iframe) {
//     var media = iframe.closest('deferred-media') || iframe.closest('.video-section-wrap');
//     if (media) {
//       var heading = media.closest('.block-section');
//       if (heading) {
//         var h = heading.querySelector('.block-section-title, h1, h2, h3');
//         if (h) return h.textContent.trim().toLowerCase();
//       }
//     }
//     return iframe.getAttribute('title') || document.title.toLowerCase();
//   }

//   function pushVideoEvent(eventName, action, videoTitle, src) {
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       event:        eventName,
//       event_action: action,
//       event_detail: videoTitle,
//       event_type:   'videoEvent',
//       video_title:  videoTitle,
//       video_url:    src
//     });
//   }

//   function listenToYouTubeIframe(iframe) {
//     var src = iframe.getAttribute('src') || '';
//     if (tracked[src]) return;
//     tracked[src] = { play: false, complete: false, milestones: {} };

//     // Ask iframe to send player state changes via postMessage
//     try {
//       iframe.contentWindow.postMessage(JSON.stringify({
//         event: 'listening',
//         id: 1,
//         channel: 'widget'
//       }), '*');
//       iframe.contentWindow.postMessage(JSON.stringify({
//         event: 'command',
//         func: 'addEventListener',
//         args: ['onStateChange']
//       }), '*');
//     } catch (e) { /* cross-origin – ignore */ }

//     var state = tracked[src];
//     var videoTitle = getVideoTitle(iframe);
//     var progressThresholds = [25, 50, 75];

//     window.addEventListener('message', function (msg) {
//       var data;
//       if (typeof msg.data === 'string') {
//         try { data = JSON.parse(msg.data); } catch (_) { return; }
//       } else {
//         data = msg.data;
//       }
//       if (!data || !data.event) return;

//       // --- State change events (play / complete) ---
//       if (data.event === 'onStateChange') {
//         var playerState = data.info;
//         // YouTube states: -1 unstarted, 0 ended, 1 playing, 2 paused, 3 buffering

//         if (playerState === 1 && !state.play) {
//           state.play = true;
//           pushVideoEvent('ctu_video_play', 'video play', videoTitle, src);
//         }

//         if (playerState === 0 && !state.complete) {
//           state.complete = true;
//           pushVideoEvent('ctu_video_complete', 'video complete', videoTitle, src);
//         }
//       }

//       // --- Progress events via infoDelivery (25%, 50%, 75%) ---
//       if (data.event === 'infoDelivery' && data.info) {
//         var currentTime = data.info.currentTime;
//         var duration    = data.info.duration;
//         if (typeof currentTime !== 'number' || typeof duration !== 'number' || duration <= 0) return;

//         var pct = (currentTime / duration) * 100;
//         for (var i = 0; i < progressThresholds.length; i++) {
//           var t = progressThresholds[i];
//           if (pct >= t && !state.milestones[t]) {
//             state.milestones[t] = true;
//             pushVideoEvent('ctu_video_progress', 'video ' + t + ' play', videoTitle, src);
//           }
//         }
//       }
//     });
//   }

//   // Observe the DOM for YouTube iframes injected by deferred-media
//   var observer = new MutationObserver(function (mutations) {
//     mutations.forEach(function (m) {
//       m.addedNodes.forEach(function (node) {
//         if (node.nodeType !== 1) return;
//         var iframes = node.tagName === 'IFRAME' ? [node] : Array.prototype.slice.call(node.querySelectorAll('iframe'));
//         iframes.forEach(function (iframe) {
//           if ((iframe.src || '').indexOf('youtube.com') !== -1) {
//             listenToYouTubeIframe(iframe);
//           }
//         });
//       });
//     });
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Also check any iframes already on the page
//   Array.prototype.slice.call(document.querySelectorAll('iframe')).forEach(function (iframe) {
//     if ((iframe.src || '').indexOf('youtube.com') !== -1) {
//       listenToYouTubeIframe(iframe);
//     }
//   });
// })();


/* ------------------------------------------------------------------
 * Shopify + YouTube (Iframe API via postMessage)
 *
 * Fires dataLayer events:
 *   - ctu_video_play
 *   - ctu_video_progress (25%, 50%, 75%)
 *   - ctu_video_complete
 *
 * Requirements:
 *   - YouTube iframe URL must contain enablejsapi=1
 *   - Works with Shopify deferred-media lazy loaded iframes
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  // Prevent duplicate tracking per iframe
  var trackedVideos = new WeakMap();

  // Only attach one global message listener
  var globalListenerAttached = false;

  function getVideoTitle(iframe) {
    // Try section heading
    var section = iframe.closest('.shopify-section');
    if (section) {
      var heading = section.querySelector('h1, h2, h3, .title, .heading');
      if (heading && heading.textContent.trim()) {
        return heading.textContent.trim().toLowerCase();
      }
    }

    // Fallback to iframe title
    var title = iframe.getAttribute('title');
    if (title) return title.trim().toLowerCase();

    // Final fallback
    return document.title.toLowerCase();
  }

  function pushVideoEvent(eventName, action, videoTitle, videoUrl) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      event_action: action,
      event_detail: videoTitle,
      event_type: 'videoEvent',
      video_title: videoTitle,
      video_url: videoUrl
    });

    console.log('GTM video event:', eventName, videoTitle);
  }

  function ensureEnableJsApi(url) {
    try {
      var u = new URL(url, window.location.origin);

      if (
        u.hostname.indexOf('youtube.com') === -1 &&
        u.hostname.indexOf('youtu.be') === -1
      ) {
        return url;
      }

      if (!u.searchParams.get('enablejsapi')) {
        u.searchParams.set('enablejsapi', '1');
      }

      if (!u.searchParams.get('origin')) {
        u.searchParams.set('origin', window.location.origin);
      }

      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function isYouTubeIframe(iframe) {
    var src = iframe.getAttribute('src') || '';
    return (
      src.indexOf('youtube.com/embed/') !== -1 ||
      src.indexOf('youtube-nocookie.com/embed/') !== -1
    );
  }

  function attachGlobalMessageListener() {
    if (globalListenerAttached) return;
    globalListenerAttached = true;

    window.addEventListener('message', function (event) {
      if (
        !event.origin.match(/^https:\/\/www\.youtube(-nocookie)?\.com$/)
      ) {
        return;
      }

      var data;
      try {
        data =
          typeof event.data === 'string'
            ? JSON.parse(event.data)
            : event.data;
      } catch (e) {
        return;
      }

      if (!data || !data.event) return;

      // Find matching iframe
      var iframes = document.querySelectorAll(
        'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]'
      );

      var matchedIframe = null;

      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow === event.source) {
          matchedIframe = iframes[i];
          break;
        }
      }

      if (!matchedIframe) return;

      var state = trackedVideos.get(matchedIframe);
      if (!state) return;

      // PLAY / COMPLETE
      if (data.event === 'onStateChange') {
        var playerState = data.info;

        // 1 = playing
        if (playerState === 1 && !state.played) {
          state.played = true;
          pushVideoEvent(
            'ctu_video_play',
            'video play',
            state.title,
            state.src
          );
        }

        // 0 = ended
        if (playerState === 0 && !state.completed) {
          state.completed = true;
          pushVideoEvent(
            'ctu_video_complete',
            'video complete',
            state.title,
            state.src
          );
        }
      }

      // PROGRESS TRACKING
      if (data.event === 'infoDelivery' && data.info) {
        var currentTime = data.info.currentTime;
        var duration = data.info.duration;

        if (
          typeof currentTime !== 'number' ||
          typeof duration !== 'number' ||
          duration <= 0
        ) {
          return;
        }

        var percentage = (currentTime / duration) * 100;
        var milestones = [25, 50, 75];

        for (var j = 0; j < milestones.length; j++) {
          var milestone = milestones[j];

          if (
            percentage >= milestone &&
            !state.milestones[milestone]
          ) {
            state.milestones[milestone] = true;

            pushVideoEvent(
              'ctu_video_progress',
              'video ' + milestone + '% played',
              state.title,
              state.src
            );
          }
        }
      }
    });
  }

  function listenToYouTubeIframe(iframe) {
    if (!iframe || trackedVideos.has(iframe)) return;
    if (!isYouTubeIframe(iframe)) return;

    // Ensure enablejsapi=1 is present
    var originalSrc = iframe.getAttribute('src') || '';
    var updatedSrc = ensureEnableJsApi(originalSrc);

    if (originalSrc !== updatedSrc) {
      iframe.setAttribute('src', updatedSrc);

      // Wait until iframe reloads
      iframe.addEventListener(
        'load',
        function () {
          setTimeout(function () {
            initializePlayer(iframe);
          }, 1000);
        },
        { once: true }
      );
      return;
    }

    initializePlayer(iframe);
  }

  function initializePlayer(iframe) {
    if (trackedVideos.has(iframe)) return;

    var src = iframe.getAttribute('src') || '';
    var title = getVideoTitle(iframe);

    trackedVideos.set(iframe, {
      src: src,
      title: title,
      played: false,
      completed: false,
      milestones: {}
    });

    // Ask YouTube to send events
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'listening',
          id: iframe.id || 'yt-player'
        }),
        '*'
      );

      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'addEventListener',
          args: ['onStateChange']
        }),
        '*'
      );
    } catch (e) {
      console.warn('Unable to initialize YouTube tracking', e);
    }
  }

  function observeYouTubeIframes() {
    // Existing iframes
    document
      .querySelectorAll(
        'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]'
      )
      .forEach(listenToYouTubeIframe);

    // Watch for lazy-loaded iframes
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          // Direct iframe
          if (node.tagName === 'IFRAME') {
            listenToYouTubeIframe(node);
            return;
          }

          // Nested iframes
          var iframes = node.querySelectorAll
            ? node.querySelectorAll(
                'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]'
              )
            : [];

          iframes.forEach(listenToYouTubeIframe);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize
  attachGlobalMessageListener();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeYouTubeIframes);
  } else {
    observeYouTubeIframes();
  }
})();


/* ------------------------------------------------------------------
 * 6. VIEW PROMOTION  (Homepage banners, buttons, slideshow clicks)
 *    Fires ctu_view_promotion when any promotional element is clicked
 *    on the homepage: slideshow slides, CTA sections, collection
 *    banners, video-background buttons, brand cards, etc.
 *    Also fires on slideshow:slide-change (swipe / arrow navigation).
 * ------------------------------------------------------------------ */
(function () {

  function pushPromoEvent(action, promoName, promoId, creativeSlot, locationId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:            'ctu_view_promotion',
      event_action:     action,
      event_detail:     promoName,
      event_type:       'promotionEvent',
      // ecommerce: {
      //   promotion_id:   promoId,
      //   promotion_name: promoName,
      //   creative_slot:  creativeSlot,
      //   location_id:    locationId || ''
      // }
    });
  }

  /**
   * Walks up the DOM from a clicked link/button to find the nearest
   * identifiable section or block, and extracts a promotion name,
   * id, and creative slot from it.
   */
  function resolvePromoContext(link) {
    // 1. Slideshow slide
    var slide = link.closest('.slideshow-slide');
    if (slide) {
      var slideHeading = slide.querySelector('.slideshow-heading, h1, h2, h3');
      var slideIdx = 0;
      var siblings = slide.parentElement ? slide.parentElement.querySelectorAll('.slideshow-slide') : [];
      for (var s = 0; s < siblings.length; s++) { if (siblings[s] === slide) { slideIdx = s; break; } }
      return {
        name: slideHeading ? slideHeading.textContent.trim().toLowerCase() : 'slide ' + (slideIdx + 1),
        id:   slide.getAttribute('id') || 'slide-' + (slideIdx + 1),
        slot: 'slideshow-slide-' + (slideIdx + 1)
      };
    }

    // 2. CTA section
    var cta = link.closest('.section-cta-wrap');
    if (cta) {
      var ctaSection = cta.closest('.shopify-section') || cta;
      var ctaHeading = cta.querySelector('h1, h2, h3, .section-cta-heading');
      return {
        name: ctaHeading ? ctaHeading.textContent.trim().toLowerCase() : 'call to action',
        id:   ctaSection.getAttribute('id') || 'cta',
        slot: 'cta-section'
      };
    }

    // 3. Video background section
    var videoBg = link.closest('.video-background-section-wrap');
    if (videoBg) {
      var vbSection = videoBg.closest('.shopify-section') || videoBg;
      var vbHeading = videoBg.querySelector('h1, h2, h3');
      return {
        name: vbHeading ? vbHeading.textContent.trim().toLowerCase() : 'video background',
        id:   vbSection.getAttribute('id') || 'video-background',
        slot: 'video-background-section'
      };
    }

    // 4. Countdown banner
    var countdown = link.closest('.section-countdown-banner-wrap');
    if (countdown) {
      var cbSection = countdown.closest('.shopify-section') || countdown;
      var cbHeading = countdown.querySelector('h1, h2, h3');
      return {
        name: cbHeading ? cbHeading.textContent.trim().toLowerCase() : 'countdown banner',
        id:   cbSection.getAttribute('id') || 'countdown-banner',
        slot: 'countdown-banner-section'
      };
    }

    // 5. Collection card overlay (collection-list, promotion-blocks, image-banners)
    var cardOverlay = link.closest('.card-overlay');
    if (cardOverlay) {
      var coSection = cardOverlay.closest('.shopify-section') || cardOverlay;
      var coHeading = cardOverlay.querySelector('.card-overlay-heading, h1, h2, h3');
      return {
        name: coHeading ? coHeading.textContent.trim().toLowerCase() : 'collection banner',
        id:   coSection.getAttribute('id') || 'collection-banner',
        slot: 'collection-card'
      };
    }

    // 6. Brand card
    var brandCard = link.closest('.card-simple');
    if (brandCard) {
      var brSection = brandCard.closest('.shopify-section') || brandCard;
      var brandImg = brandCard.querySelector('img');
      return {
        name: brandImg ? (brandImg.getAttribute('alt') || '').toLowerCase() || 'brand' : 'brand',
        id:   brSection.getAttribute('id') || 'brands',
        slot: 'brand-card'
      };
    }

    // 7. Media with text
    var mwt = link.closest('.media-with-text');
    if (mwt) {
      var mwtSection = mwt.closest('.shopify-section') || mwt;
      var mwtHeading = mwt.querySelector('h1, h2, h3');
      return {
        name: mwtHeading ? mwtHeading.textContent.trim().toLowerCase() : 'media with text',
        id:   mwtSection.getAttribute('id') || 'media-with-text',
        slot: 'media-with-text-section'
      };
    }

    // 8. Generic fallback – any shopify-section on homepage
    var section = link.closest('.shopify-section');
    if (section) {
      var secHeading = section.querySelector('h1, h2, h3, .block-section-title');
      return {
        name: secHeading ? secHeading.textContent.trim().toLowerCase() : 'homepage section',
        id:   section.getAttribute('id') || 'homepage-section',
        slot: 'homepage-section'
      };
    }

    return {
      name: link.textContent.trim().toLowerCase() || 'homepage link',
      id:   'homepage',
      slot: 'homepage'
    };
  }

  function onReady() {
    // Only run on homepage
    var isHomepage = window.location.pathname === '/' ||
                     document.querySelector('body.template-index') !== null;
    if (!isHomepage) return;

    // Delegate: catch clicks on any <a> or <button> inside shopify sections
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href], button');
      if (!link) return;

      // Skip product-form add-to-cart buttons (already tracked separately)
      if (link.closest('product-form') || link.closest('product-card')) return;

      // Skip navigation / header / footer / mini-cart
      if (link.closest('header, footer, .header, .footer, mini-cart, .mini-cart, nav')) return;

      // Must be inside a shopify-section on the page
      var section = link.closest('.shopify-section');
      if (!section) return;

      var ctx = resolvePromoContext(link);
      var href = link.getAttribute('href') || '';

      pushPromoEvent('promotion click', ctx.name, ctx.id, ctx.slot, href);
    });

    // Slideshow slide-change (swipe / arrow navigation)
    document.addEventListener('slideshow:slide-change', function (event) {
      var detail = event.detail || {};
      var index  = typeof detail.index === 'number' ? detail.index : 0;
      var componentId = detail.id || '';
      var component   = componentId ? document.getElementById(componentId) : null;
      var slideEl     = component
        ? component.querySelectorAll('.slideshow-slide')[index]
        : null;

      var headingEl = slideEl ? slideEl.querySelector('.slideshow-heading, h1, h2, h3') : null;
      var promoName = headingEl ? headingEl.textContent.trim().toLowerCase() : 'slide ' + (index + 1);
      var promoId   = slideEl ? (slideEl.getAttribute('id') || 'slide-' + (index + 1)) : 'slide-' + (index + 1);

      pushPromoEvent('promotion impression', promoName, promoId, 'slideshow-slide-' + (index + 1), '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();